import React from 'react';
import { FormControlLabel, Radio, RadioProps } from '@material-ui/core';

interface RadioLabelledProps extends RadioProps {
  value: string | number | null | boolean;
  label: string;
}

export const RadioLabelled = ({
  value,
  label,
  ...rest
}: RadioLabelledProps) => (
  <FormControlLabel
    value={value}
    style={{ width: 'fit-content' }}
    control={<Radio {...rest} color="primary" />}
    label={label}
  />
);
